import React from "react";

const SvgLowConfidence = (props) => (
  <svg width={67} height={66} {...props}>
    <g fill="none" fillRule="evenodd">
      <circle stroke="#E1E1E1" strokeWidth={3.78} cx={33} cy={33} r={31.11} />
      <path
        d="M63.91 34.326C65.476 16.91 52.664 3.64 34.53 2.096"
        stroke="#FBA3A3"
        strokeWidth={4.08}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgLowConfidence;
